import type {PublicMethodUtils} from '@wix/document-services-types'
import type {InlinePopupPublicAPI} from '@wix/document-services-public-types'
import {inlinePopup} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<InlinePopupPublicAPI> {
    return {
        methods: {
            inlinePopup: {
                setAlignment: publicMethodUtils.defineDataManipulationAction(inlinePopup.setAlignment)
            }
        }
    }
}
